
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"36","viewBox":"0 0 102 62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".753","width":"100.591","height":"62","rx":"4","fill":"#ECC3FF"}}),_c('ellipse',{attrs:{"cx":"87.551","cy":"32.359","rx":"10.194","ry":"10.161","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M90.65 32.092a.3.3 0 010 .534l-5.378 2.752a.3.3 0 01-.437-.267v-5.503a.3.3 0 01.437-.268l5.379 2.752z","fill":"#fff"}}),_c('ellipse',{attrs:{"cx":"63.5","cy":"32.359","rx":"10.194","ry":"10.161","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M66.6 32.092a.3.3 0 010 .534l-5.379 2.752a.3.3 0 01-.436-.267v-5.503a.3.3 0 01.436-.268l5.379 2.752z","fill":"#fff"}}),_c('ellipse',{attrs:{"cx":"39.378","cy":"32.359","rx":"10.194","ry":"10.161","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M42.478 32.092a.3.3 0 010 .534l-5.379 2.752a.3.3 0 01-.437-.267v-5.503a.3.3 0 01.437-.268l5.379 2.752z","fill":"#fff"}}),_c('ellipse',{attrs:{"cx":"15.326","cy":"32.359","rx":"10.194","ry":"10.161","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M18.425 32.092a.3.3 0 010 .534l-5.379 2.752a.3.3 0 01-.436-.267v-5.503a.3.3 0 01.436-.268l5.38 2.752z","fill":"#fff"}}),_c('rect',{attrs:{"x":"6.129","y":"9.951","width":"39.929","height":"4.593","rx":"2.296","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"6.129","y":"50.519","width":"72.18","height":"4.593","rx":"2.296","fill":"#B758E5"}})])
          )
        }
      }
    